import {
  accountDescription,
  assetDescription,
  breakDescription,
  buildEntityDescriptions,
  clearwaterTransactionDescription,
  declareCommentaryContext,
  describeEntity,
} from '@helios/comments'
import { Break } from '../../model/break.model'
import {
  breakOrigTranIdFromMetaData,
  breakTransactionLabelPartsFromMetaData,
} from '../../utils/metadata-columns'

export const breakCommentary = declareCommentaryContext<Break>()({
  fields: [
    'acctId',
    'accountName',
    'identifier',
    'metaData',
    'securityIdentifier',
    'displayName',
    'startDate',
  ],
  build: brk => {
    const transactionId = breakOrigTranIdFromMetaData(brk)
    return {
      accountId: brk.acctId?.toString(),
      breakId: brk.identifier,
      transactionId,
      assetId: brk.securityIdentifier,
      entityDescriptions: buildEntityDescriptions([
        describeEntity(
          'account',
          brk.acctId,
          accountDescription({ accountName: brk.accountName }),
        ),
        describeEntity(
          'break',
          brk.identifier,
          breakDescription({
            displayName: brk.displayName,
            startDate: brk.startDate,
            securityIdentifier: brk.securityIdentifier,
          }),
        ),
        describeEntity(
          'tran',
          transactionId,
          clearwaterTransactionDescription(
            breakTransactionLabelPartsFromMetaData(brk),
          ),
        ),
        describeEntity(
          'asset',
          brk.securityIdentifier,
          assetDescription({ secIdentifier: brk.securityIdentifier }),
        ),
      ]),
    }
  },
})
